import { Box, Flex, Icon, Stack, Tag, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { FiLock } from "react-icons/fi";
import { useSettledTerms } from "./useSettledTerms";

// FOA § 26-3: these are fixed by the framework competition and cannot be reopened per call-off.
export const InheritedTermsCard = ({ frameworkAgreementId }: { frameworkAgreementId: string }) => {
  const { t } = useTranslation();
  const settled = useSettledTerms(frameworkAgreementId);

  if (!settled || settled.registeredByHand) return null;

  const rows = [
    {
      label: t("Qualification criteria"),
      value: settled.qualificationCriteriaCount
        ? t("{{count}} settled", { count: settled.qualificationCriteriaCount })
        : t("None"),
    },
    {
      label: t("Minimum requirements"),
      value: settled.minimumRequirementCount
        ? t("{{count}} settled", { count: settled.minimumRequirementCount })
        : t("None"),
    },
    { label: t("Suppliers on the panel"), value: String(settled.framework.summary.supplierCount) },
  ];

  return (
    <Box borderWidth="1px" borderColor="smBorder" bg="smBackgroundSecondary" rounded="md" p="4" mb="6">
      <Flex align="center" gap="2">
        <Icon as={FiLock} color="smMuted" />
        <Text fontWeight="semibold" fontSize="sm">
          {t("Settled by the framework competition")}
        </Text>
      </Flex>
      <Text fontSize="sm" color="smMuted" mt="1">
        {t("These terms apply to every call-off and are not asked again.")}
      </Text>
      <Stack mt="3" spacing="2">
        {rows.map((row) => (
          <Flex key={row.label} justify="space-between" align="center" gap="3">
            <Text fontSize="sm">{row.label}</Text>
            <Tag size="sm" variant="subtle">
              {row.value}
            </Tag>
          </Flex>
        ))}
      </Stack>
    </Box>
  );
};
